// import { useHistory } from 'react-router-dom';
// import { useEffect } from 'react';
import { create } from "zustand";
import { devtools } from "zustand/middleware";

export const actions = {
  /** Log in the provided user. Payload is the new user object. */
  LOGIN: "LOGIN",
  // /** Log out the current user. No payload. */
  // LOGOUT: 'LOGOUT',
  /** Display a toast. Payload { String message, Number statusCode } */
  TOAST: "TOAST",
  /** Clear the current toast. No payload. */
  UNTOAST: "UNTOAST",
  /** Set the message list. Payload is an array of messages. */
  UPDATE_MESSAGES: "UPDATE_MESSAGES",
  /** Reset the message lsit. No payload. */
  RESET_MESSAGES: "RESET_MESSAGES",
};

const reducer = (state, action) => {
  switch (action.type) {
    case actions.LOGIN:
      return {
        user: {
          ...state.user,
          token: action.payload,
        },
      };
    // case actions.LOGOUT:
    //   return {
    //     user: initialState.user,
    //     toast: toastFor(action, 'Log out successful', 200)
    //   };
    case actions.TOAST:
      return { toast: { ...state.toast, ...action.payload } };
    case actions.UNTOAST:
      return { toast: state.toast };
    case actions.UPDATE_MESSAGES:
      return { messages: action.payload };
    case actions.RESET_MESSAGES:
      return { messages: state.messages };
    default:
      return state;
  }
};

export const pathTitles = {
  HOME: "Home",
  CHOOSINGAPUPPY: "Choosing Your Puppy",
  YOURPUPPYSTRAINING: "Your Puppy's Training",
  PUPPYDELIVERY: "Puppy Delivery",
  PUPPYADVICE: "Puppy Advice",
  VIEWPUPPIES: "View Puppies",
  PUPPYPROFILE: "Trained Puppies",
  CONTACTUS: "Contact Us",
};

export const useStore = create(
  devtools((set, get) => ({
    dispatch: (args) => set((state) => reducer(state, args)),
    user: {
      username: "todosadmin",
      password: "1234",
      token: "",
    },
    messages: [],
    toast: {
      message: "",
      statusCode: 0,
    },
    paths: [
      {
        displayName: pathTitles.HOME,
        path: "/",
        header: true,
        footer: false,
        dropDown: false,
      },
      {
        displayName: pathTitles.CHOOSINGAPUPPY,
        path: "/choosing-your-puppy",
        header: true,
        footer: false,
        dropDown: false,
      },
      {
        displayName: pathTitles.YOURPUPPYSTRAINING,
        path: "/puppy-training",
        header: true,
        footer: false,
      },
      {
        displayName: pathTitles.PUPPYDELIVERY,
        path: "/puppy-delivery",
        header: true,
        footer: false,
      },
      // {
      //   displayName: pathTitles.PUPPYADVICE,
      //   path: "/puppy-advice",
      //   header: true,
      //   footer: false,
      // },
      {
        displayName: pathTitles.VIEWPUPPIES,
        path: "/trained-puppies-for-sale",
        header: true,
        footer: false,
      },
      {
        displayName: pathTitles.PUPPYPROFILE,
        path: "/trained-puppies",
        header: false,
        footer: false,
      },
      {
        displayName: pathTitles.CONTACTUS,
        path: "/contact-us",
        header: true,
        footer: true,
        dropDown: false,
      },
    ],
    getLink: (title) => {
      const link = get().paths.find((path) => path.displayName === title).path;
      return link;
    },
    getSnippet: (str) => {
      return `${str.substring(0, 130).trim()}...`;
    },
    buildServices: (service) => {
      return {
        title: get().trainingDetails[service].title,
        info: get().getSnippet(get().trainingDetails[service].body.info),
        link: get().getLink(pathTitles[service]),
      };
    },
    addService: (obj, service, value) => {
      set((state) => ({
        trainingDetails: {
          ...state.trainingDetails,
          [obj]: {
            ...state.trainingDetails[obj],
            body: {
              ...state.trainingDetails[obj].body,
              otherServices: {
                ...state.trainingDetails[obj].body.otherServices,
                [service]: get().buildServices(value),
              },
            },
          },
        },
      }));
    },
    checkServices: (obj) => {
      for (const type in obj) {
        if ("otherServices" in obj[type].body) {
          for (const service in obj[type].body.otherServices) {
            let value = obj[type].body.otherServices[service];
            if (typeof value == "string") {
              get().addService(type, service, value);
            }
          }
        }
      }
      set({
        loading: false,
      });
    },
    loading: true,
    setLoading: (load) => {
      set({
        loading: load,
      });
    },

    trainingDetails: {
      ALLTRAININGPROGRAMS: {
        body: {
          title:
            "We offer an exceptional training experience for puppies and dogs.",
          info: "Todo’s Translator is here to provide an enjoyable and effective training experience for both you and your dog.   Choose in home lessons alone to teach you how to train your dog yourself or get extra help from Todo’s owner and trainer, Justine, through Day Training or Board and Train.   Justine is here to help you learn how to have a more peaceful relationship with your dog.",
          image: "trainingAll",
          imageCaption:
            "Grace and friends practice holding a down while Justine cooks dinner.",
          otherServices: {
            privateLessons: "PRIVATELESSONS",
            dayTraining: "DAYTRAINING",
            boardAndTrain: "BOARDANDTRAIN",
            buyAPuppy: "BUYATRAINEDPUPPY",
          },
          moreInfo: [
            "How to start? Contact us to schedule a non-committal Consultation ($40) to make a Training Plan specific to your situation and goals.",
          ],
        },
      },
      PRIVATELESSONS: {
        title: pathTitles.PRIVATELESSONS,
        body: {
          title:
            "Give your dog the best experience with our private dog training program.",
          info: "Does your dog sometimes have a hard time being around other dogs? Is your dog easily excitable around other furry friends? If so, you should take advantage of our private dog training program offered right here in Indianapolis, Indiana. Our experienced, dedicated, and qualified owner has loved dogs ever since she was young. Today, she has over 7 years of experience as a professional dog trainer, and a lifetime as a pet owner.",
          image: "privateLessons",
          imageCaption:
            "A client's dog out to lunch with Justine, practicing positive associations with dogs and people as well as impulse control.",
          moreInfo: [
            "All programs offered will include Lessons for the owners to learn how to work with their dog in their home or where the problem behaviors are occurring.  With years of experience and hundreds of dogs trained Justine is able to offer you individualized solutions to your dog related problems.",
            "During lessons we will focus on teaching you how to handle your dog in a way that reinforces wanted behaviors and makes unwanted behaviors less successful to your dog (and therefore less likely to be repeated).",
            "Keep in mind that dog training is a process. It is daily routine and proper communication with our dogs. It is hard work creating a relationship built on trust and fellowship. Just like everything in life the more you put into it the more you get out of it. Do your best to make training your dog a lifestyle.",
            "Private lessons are a great option for Justine to teach you how to train your dog. Because a large majority of dog training is repetition it is up to you to do the reps. Just like going to the gym, you must work on a regular basis with your dog to attain your goals.",
            "To be sure that you get the most out of your training sessions please make your priorities clear so that the focus is on what is important to you. Justine’s goal is to leave you with enough understanding of how to train dogs that you become her “apprentice dog trainers”.",
          ],
        },
      },
      BOARDANDTRAIN: {
        title: pathTitles.BOARDANDTRAIN,
        body: {
          title:
            "Our boarding and training programs are available for puppies and dogs.",
          info: "At Todo's Translator, we offer a unique boarding and training experience for puppies and dogs that provides a 24/7 immersive training experience. Your dog receives real-world environment training that translates perfectly into your home lifestyle. During a Board and Train through Todo’s Translator your dog goes to live with owner and trainer, Justine in her home for a faster paced, more immersive solution. Your dog will be practicing calm polite behavior every minute of the day. They also will be treated as a member of the family with lots of love, cuddles and play time in the half acre yard with other dogs.",
          image: "boardAndTrain",
          imageCaption:
            "Board and train dogs in Justine's living room, practicing positive associations with cats and impulse control in real life environments.",
          moreInfo: [
            "Board and Train is the fastest, most effective way to see a dramatic change in your dog’s behavior.",
          ],
          otherServices: {
            puppyTraining: "BOARDANDTRAINPUPPY",
            boardAndTrain: "BOARDANDTRAINADULT",
          },
        },
      },
      BOARDANDTRAINADULT: {
        title: pathTitles.BOARDANDTRAINADULT,
        body: {
          title:
            "Obedience training comes with a number of benefits for both you and your dog.",
          info: "Finding the right dog trainer can be tough, but the Todo's Translator team is here to provide this important service. We offer obedience training to dogs located throughout the Indianapolis, Indiana area. The most effective, fast paced option available to train your dog is Board and Train. Your dog would come to live with Justin, owner & trainer, and her family in their home for the most intensive part of its training. Every dog who comes to stay is treated as one of the pack. While there is a lot of training and work that gets done there is also plenty of snuggles, play time and rest. Enjoy peace of mind knowing that Justine will do all the hard work and your dog will be happy and well cared for.",
          image: "btAdult",
          imageCaption:
            "Jax on walk with Justine, working on reactivity towards people, leaf blowing, cars, and dogs.",
          moreInfo: [
            "Obedience training comes with a number of benefits for both you and your dog. Many public places allow well-behaved dogs, including stores, public beaches, and outdoor event venues. You might also take a trained dog on a hike or swimming in a public lake. When properly trained, a dog can participate in many of the activities that you and your family enjoy doing. Obedience training can also help to keep your dog safe, as they’ll respond to your commands and exhibit good behavior in a wide range of circumstances and situations.",
            "You can choose from several obedience training options, depending on the age of your dog and what you want to get out of the experience. We offer several board-and-train programs, which involve leaving your dog with us for several weeks for boarding and professional training. You can also schedule your dog for one-on-one private training or in-home training lessons. Check out all our different programs to see what you feel is best for your dog!",
          ],
          otherServices: {
            puppyTraining: "BOARDANDTRAINPUPPY",
            privateLessons: "PRIVATELESSONS",
          },
        },
      },
      BOARDANDTRAINPUPPY: {
        title: pathTitles.BOARDANDTRAINPUPPY,
        body: {
          title:
            "Our puppy training will get your puppy started out on the right paw.",
          info: "There is a lot to be said for getting started early with dog training. At Todo's Translator, we offer three puppy programs for puppies between 9 weeks and 4 months of age. We do all the foundational work for your puppy. This includes starting crate training, potty training, socialization, and all basic obedience at a puppy level. Your puppy will also get much needed exposure/socialization. You select the amount of time your dog stays with us. These programs do not get you a fully trained dog, but it gets them started out on the right track.",
          image: "btPuppy",
          imageCaption: "Rowan taking a nap on Justine's back porch.",
          moreInfo: [
            "You have three choices for puppy training. Our puppy primer program is $700 per week with you choosing how long your puppy stays with us. The second option is our polite puppy package where you learn how to train your puppy. You receive six 30-minute private lessons and intensive training for $650 a week (minimum of 4 weeks to book). We discuss all things puppy: potty training, crate training, socialization, puppy nipping, and more. We also get a foundational start on all your basic obedience commands. This is the perfect way to learn how to train your dog and get them started out on the right paw! The third option is the perfect puppy program, where Todo's does all of the work for you. For $600 a week, (minimum 6 weeks to book), and 8 in home lessons this program is key to having a dog that responds to commands no matter the situation.",
            "As your puppy grows, you can shift from puppy training to our other dog training offerings. Once again, you can choose from the board and train experience or as additional one-on-one lessons that go over the next phase of dog training, namely basic obedience. Let us know if you have any questions about our puppy training or other services.",
          ],
          otherServices: {
            privateLessons: "PRIVATELESSONS",
            boardAndTrain: "BOARDANDTRAINADULT",
          },
        },
      },
      BUYATRAINEDPUPPY: {
        title: pathTitles.BUYATRAINEDPUPPY,
        body: {
          title:
            "A Trained Puppy from Todo’s Translator has the knowledge and experience necessary to behave as we expect a ‘good dog’ to behave.",
          info: "The puppy will learn how to live a cooperative life with humans; what is allowed, what isn’t, and how to be an all around family dog. Each puppy is handpicked and hand raised by Justine in her home with her dog pack.  Justine starts by searching for the right breeder.  Many aspects of a dog’s overall health and temperament are determined by genetics and early experiences so choosing the right breeder is vital. Once she chooses the breeder she makes sure that she chooses the right litter and right pup.  Justine checks the health and temperament of both parents, then watch how the puppies interact with one another to be sure she brings the perfect personality home.",
          image: "buyATrainedPuppy",
          imageCaption:
            "Tinker, Rukus, and Grace - all sold trained puppies - learned what swimming was and how to do it!",
          otherServices: {
            buyAPupWeb: {
              title: "Ready to find your new family member?",
              info: "The thought of raising a new puppy on your own is overwhelming. You want a dog that will fit perfectly with your lifestyle. Your life...",
              link: "website/buyATrainedPuppy",
            },
            puppyTraining: "BOARDANDTRAINPUPPY",
          },
        },
      },
      DAYTRAINING: {
        title: pathTitles.DAYTRAINING,
        body: {
          title:
            "Day Training is an opportunity for Justine to take on some of the repetition for you.",
          info: "Day Training is for your dog to spend time with Justine one on one – no owners.  Justine spends up to 3 hours per session with your dog working on specific goals.  These sessions are great for extra repetition, to troubleshoot problems, or to introduce tools.  Justine may work with your dog in your home or out in public.  Day Training is always followed by a lesson the next day to teach you what your dog has learned.",
          image: "dayTraining",
          imageCaption:
            "Dogs practicing a stay command inside the house while their owners work in the garden with the garage door open.",
          moreInfo: [
            "During a ‘Day Training’ session Justine will pick your dog up in the morning, he will spend the day working towards the goals we had agreed upon during our consultation, and Justine will return him to you in the evening and spend 30 minutes teaching you what Justine has taught him.",
            "This program is ideal for:",
            "- Owners who don’t have the time necessary to address their dog’s issue(s)",
            "- Dogs who need more one on one time with the trainer",
            "- Dogs who do not do well when left home alone during the day",
            "- Puppy Raising, house training and socialization",
            "- New rescue dogs that need help adjusting",
            "- Troubleshooting (ex: dog won'the perform outside/in public, leash pulling, etc)",
            "NOTE: This is unlike training programs at boarding/daycare facilities.  Justine will be spending the day with only your dog, instead of one training session while your dog spends the rest of the day at daycare.   Whether your pup realizes it or not he will be learning all day long.  We will train, play, take a break, repeat.  Even when he’s taking a break he will still be learning how to be a relaxed, calm guy.  Training will occur in whatever environment is conducive to your dog’s learning style. This can include in the car, at my home, in my half acre fenced yard, on walks, on the Monon Trail, at dog friendly restaurants, pet stores, or possibly dog parks (if your dog has a tag).   Whichever environment works best for your dog at that point in his education is where we will practice.  The activities your dog and Justine do will reflect your lifestyle and training goals and will therefore be more productive in the long run.",
          ],
          otherServices: {
            buyAPuppy: "BUYATRAINEDPUPPY",
            privateLessons: "PRIVATELESSONS",
          },
        },
      },
      BOARDING: {
        displayName: pathTitles.BOARDING,
        body: {
          title:
            "We offer a different kind of dog boarding experience we think you and your dog will love.",
          info: "There are many dog boarding facilities out there that focus only on providing a safe place for your dog to be when you have to go out of town on business or vacation. Here at Sublime K9 Training & Boarding, our primary focus is on dog training where your dog stays with us while we get them trained for you. Dog boarding is part of the board & train process in this case. However, we do offer regular dog boarding when space allows.",
          image: "boardAndTrain",
          imageCaption:
            "Boarding dogs relaxing in Justine's living room, practicing calm behavior around cats and other real-life distractions.",
          moreInfo: [
            "Our dog boarding experience includes as many let outs as your dog needs, and if your dog is social, it also includes plenty of supervised playtime with other dogs! You must pack your dog’s own food. All dogs must be current on all vaccines, including kennel cough.​",
            "Our kennel runs are indoor only and 4 ft by 4 ft. Each has its own raised dog bed for comfort, and blankets are welcome as long as your dog does not chew them. We chose to do indoor only kennels because giving your dog the outdoor option can create a bad habit of allowing your dog to use the bathroom inside the kennel. Our boarded dogs spend most of their time outside of their kennel, socializing and playing. Kennel time is for down time, feeding times, and bed time! We want your dog’s stress levels and energy levels low, so we strive to make your dog’s boarding experience fun!",
          ],
          otherServices: {
            privateLessons: "PRIVATELESSONS",
            boardAndTrain: "BOARDANDTRAIN",
          },
        },
      },
    },
    aboutDetails: {
      THETEAM: {
        title: pathTitles.MEETTHETEAM,
        body: {
          title: "From our family to yours.",
          info: "Justine Ramey is the owner and trainer at Todo’s Translator. Justine opened Todo’s for business in 2015 to help owners to have more peaceful lives with their dogs.  She wants all dog owners to understand how to have a life with their dogs that is enjoyable and fullfilling.  Justine is a member of the Association of Pet Dog Trainers and the International Assosiation of Canine Professionals.  She is constantly looking to grow and expand her knowledge base through relationships with other trainers, conferences and workshops.",
          image: "theTeam",
          imageCaption:
            "Assistant (left) and Justine (right) with 5 sold Buy A Trained Puppy puppies.",
          moreInfo: [
            "Justine wants to teach you how to have a dog that works for you because he ENJOYS it, respects you and values your relationship.",
            "Justine lives with her son, Foster, and their pack. They have Zeta, the Pitbull Mix, who is chatty and loves all humans, and Aurora, the Cane Corso Mastiff, whose happiness can be seen in her hips. Munch, the Dachshund who started it all, will always hold a special place in their hearts.",
          ],
          otherMembers: {
            ZETA: {
              title: "Meet Zeta",
              info: "A vocal, eager to please, hard worker. Zeta doesn't make fast friends, unless they're humans! She prefers to play tug, chase, or do any command asked than jump into the dog pile. Zeta is a family favorite here and would love to show you why if you'd just lay on the floor for a second.",
              link: "/meet-the-trainer/zeta",
              image: "zeta",
              imageCaption: "Zeta is ready for Justine's next request.",
            },
            GUESTS: {
              title: "Guest Helpers",
              info: "Many of our board and train puppies and dogs end up helping in lessons.  This helps the client who's lesson it is as well as the helper dog.   This is an opportunity for both to learn appropriate communication (dog/dog) as well as practice obedience and impulse control around other distractions.",
              link: "",
              image: "guests",
              imageCaption:
                "Justine walking Chico, Chester, Charlie, and Bear - all of whom came to her unable to walk on a leash.",
            },
          },
        },
      },
      JUSTINE: {
        title: pathTitles.MEETTHETEAM,
        body: {
          title: "The Team: Justine",
          info: "Justine Ramey is the owner and trainer at Todo’s Translator. She has always had a strong love for animals and for a long time believed that to work with animals she had to become a veterinarian.  Justine embarked upon that path and attended college as a pre-vet student. While the necropsies and physiology classes were fascinating, it wasn’t until she took Ethology (the study of Animal Behavior) that she found her true passion. Justine volunteered at animal shelters, and worked in pet shops. She got a job training dogs at PetsMart. Her life led her to Indianapolis where she got a job as the trainer at a boarding facility. It was here that she saw so many loving owners struggling with seemingly out of control dogs. Justine started by helping some of the boarding facility clients by doing more in depth training. She enrolled in training seminars and conferences, and soon after opened Todo's Translator.",
          image: "teamjustine",
          imageCaption:
            "Aurora and Zeta showing Justine a little appreciation.",
          moreInfo: [
            "Justine lives with her son, Foster, her niece Sierra, and their pack. They have Zeta, the Pitbull Mix, who is chatty and loves all humans, and Aurora, the Cane Corso Mastiff, whose happiness can be seen in her hips. Munch, the Dachshund who started it all, will always hold a special place in their hearts.",
            "Justine opened Todo’s Translator 5 years ago to help more dogs stay in forever homes, to help owners to fully enjoy their canine companions and to further the bond we share with our four-legged family members.",
            "Mostly, Justine wants you to have a stress-free relationship with your pooch!",
            "Justine chooses to do one on one type sessions because the success of the work depends on several factors; personality of dog and owner, what training method works best for the dog as an individual, what energy level the dog is, what motivates the dog and how motivated the owner is to make a change.  One on one sessions allow Justine to get to know your dog as an individual and to learn exactly what may work best for your personal situation.",
            "Methods:   No Force, Just Fun!",
            "Justine prides herself on using non-forceful training methods.  She uses a combination of positive reinforcement, clicker training and communicating with dogs by using and reading body language.  Her goal is to see a relationship based on mutual respect between all members of your family; two and four legged. This requires using the appropriate training tools properly, clear ‘house rules’, patience and most importantly consistency.",
            "She wants to teach you how to have a dog that wants to work for you because he enjoys it and respects you.  It’s all about communication!",
          ],
        },
      },
      ZETA: {
        title: pathTitles.MEETTHETEAM,
        body: {
          title: "The Pack: The Story of Zeta",
          info: "Zeta came to join our family in 2016.  She is some kind of mystery pitbull mutt that was given to us when we lived in Fountain Square.  Zeta has always been a tenacious and smart little thing.",
          image: "teamzeta",
          imageCaption: "Zeta races to greet the photographer.",
          moreInfo: [
            "Zeta prefers to not be with guest dogs. She has her small social group and that's enough for her and we are ok with that.  Zeta is one of the best dogs Justine has ever known and is a joy to train and share life with.",
          ],
        },
      },
    },
    testimonials: [
      {
        clientName: "Carrie",
        location: "Fishers, IN",
        comment:
          "Justine, thank you so much for your help! Dora has been so much easier to handle since we began our lessons! As you know, we first hired a trainer that used a prong collar on her and we noticed she would sometimes react worse when she encountered a dog because of it.  I am so glad that we found you!",
      },
      {
        clientName: "Megan",
        location: "Geist, IN",
        comment:
          "Justine I have to tell you how great it is to walk Snickers and not feel embarrassed!  Remember the neighbor that had made so many complaints to the Neighborhood Association? Well yesterday she came up and pet him and told me that I must’ve traded dogs with someone!  I can’t believe it!",
      },
      {
        clientName: "Janel",
        location: "Fishers, IN",
        comment:
          "Bear has been a completely new dog since he came back from his board and train!  Thanks for taking the time to make sure we knew how to handle him just like you can.",
      },
      {
        clientName: "Joe",
        location: "Indianpolis, IN",
        comment:
          "I would highly recommend hiring Todo’s Translator to help train your dog. Justine helped us with our puppy (we started at 5 months) to stop nipping, barking, pulling on leash and pooing inside.  She helped us to understand how our puppy learned those habits and how to break them.  Whenever I have a friend that gets a puppy I send them to her!",
      },
      {
        clientName: "Carl",
        location: "Carmel, IN",
        comment:
          "Justine, I am amazed with the improvements Callie has made since we first started working together.  She still sometimes gets overexcited but now I know how to handle her and help her to calm herself.  Thank you!",
      },
      {
        clientName: "Josh",
        location: "Noblesville, IN",
        comment:
          "I was skeptical when we first started working together.  I didn’t really think that {Nothing in Life is Free} would help Charlie respect me but it does!  It’s only been a few months since you suggested I make him work for everything that he gets from me and he now asks politely from anything he wants from me.  He even asks politely at the pet stores too.  Thanks for helping it all come together.",
      },
      {
        clientName: "Marge",
        location: "Indianpolis, IN",
        comment:
          "Justine impressed me immediately when she showed up exactly on time.  The week before PetPeople referred me to Justine I had scheduled an appointment with another trainer.  That trainer never showed up.  Honestly, I’m glad the first trainer didn’t bother coming because I never would have found Justine otherwise.  A few months later when I experienced health issues Justine sent me the kindest card and helped me to take care of my dog when I was too ill to do so.  I never would have expected to find a friend when I hired a dog trainer!",
      },
    ],
    getWindow: () => {
      set({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    },
    width: 0,
    height: 0,
    googleReviews: [
      {
        profileImage:
          "https://lh3.googleusercontent.com/a-/AOh14GjgRWGvDHyUc2_VrRc8eW1iWx8BB0kOdxSNMV2g2A=s40-c-c0x00000000-cc-rp-mo-br100",
        reviewerName: "Kimmie",
        stars: 5,
        positive: true,
        keywords:
          "Professionalism, Quality, Reliability, Responsiveness, Value",
        review:
          "Justine is the dog whisperer! Our 8 month old Aussie went to training with her for 4 weeks. Prior to training, he chewed everything in sight and jumped on people none stop. He had so much energy and we needed help figuring out how to help channel that energy and get him to behave. He was out of control! Since being home, he has not chewed anything, he tolerates new people and has improved 100000%,& he actually is just chill. We can finally enjoy our dog! This training has been a game changer. We appreciate everything and will always refer Justine! Hands down a miracle worker for our Aussie! *I think Jax misses you every now and then",
        images: [
          "https://lh5.googleusercontent.com/p/AF1QipMqmkTjNYPmX0q-j8JKx396eAlQt7umjMnZd4tr=w100-h100-p-n-k-no",
          "https://lh5.googleusercontent.com/p/AF1QipOCJvZodDvbh0Pqntivgd0hFizYnCtWUGUMKN5y=w100-h100-p-n-k-no",
          "https://lh5.googleusercontent.com/p/AF1QipMxgSwHaSVwjTTKzSnUq_6ieI1mIo8OUuWDvmRK=w100-h100-p-n-k-no",
        ],
      },
      {
        profileImage: "",
        reviewerName: "Pamela",
        stars: 5,
        positive: true,
        keywords: "",
        review:
          "Justine did an amazing job with my new puppy. He was stubborn but she was able to get him to be a good dog.",
        images: [
          "https://lh5.googleusercontent.com/p/AF1QipPzf5YT4uxiySn5RVO6MvwWcvj-jrGfu5rJMC99=w100-h100-p-n-k-no",
        ],
      },
      {
        profileImage:
          "https://lh3.googleusercontent.com/a-/AFdZucp9MjOpBkWE5k1hNacc49y-iJsaD6MGkyZpDUqR_Q=w60-h60-p-rp-mo-ba2-br100",
        reviewerName: "Ashley",
        stars: 5,
        positive: true,
        keywords: "Professionalism, Quality, Reliability",
        review:
          "Justine is AMAZING!!! She did miracles with my lab and continues to support me with tips and tricks even almost a year later!!! You will NOT be disappointed!",
        images: [],
      },
      {
        profileImage: "",
        reviewerName: "Angie",
        stars: 5,
        positive: true,
        keywords:
          "Professionalism, Quality, Reliability, Responsiveness, Value",
        review:
          "Justine did an amazing job with our puppy. She not only trains your dog but also trains you so that you know what to do. Highly recommend!!",
        images: [],
      },
      {
        profileImage: "",
        reviewerName: "Sophia",
        stars: 5,
        positive: true,
        keywords:
          "Professionalism, Quality, Reliability, Responsiveness, Value",
        review:
          "Justine is amazing! She is always prepared, on time and patient with our sweet pup. We are proud of the progress our dog continues to make and we owe it all to Justine. We highly recommend her!!",
        images: [
          "https://lh5.googleusercontent.com/p/AF1QipMZDGcLWZs08i0nqEN7Qb2Hpj5UqNTMlneL7vO_=w100-h100-p-n-k-no",
        ],
      },
      {
        profileImage:
          "https://lh3.googleusercontent.com/a-/AFdZucpl8xjsLL9CxaCN057fjFcKeLc_ZKAf59_YHaH-iP4=w60-h60-p-rp-mo-br100",
        reviewerName: "Ryan",
        stars: 5,
        positive: true,
        keywords: "Professionalism, Quality",
        review:
          "Love Justine! She is fluent on multiple training methods and ideologies and will work with you to find the best plan of action for your dog and the results you are looking for. Very personable as well and easy to get along with.",
        images: [],
      },
      {
        profileImage: "",
        reviewerName: "Allisa",
        stars: 5,
        positive: true,
        keywords: "Professionalism, Quality, Reliability, Responsiveness",
        review:
          "Super down to earth, knowledable and understanding trainer. I've worked with some that are harsh and almost rude, but shes compassionate and listens!  She worked with my pup Koda for his leash reactivity for 2 lessons an hr each and I could see a dramatic difference in just two lessons. Now its my time to take what she taught us and practice!  Would highly recommend!",
        images: [],
      },
      {
        profileImage: "",
        reviewerName: "Christina",
        stars: 5,
        positive: true,
        keywords:
          "Professionalism, Quality, Reliability, Responsiveness, Value",
        review:
          "My dog, Elvis (75 lb. boxer/lab), pulled on his harness for walks. He was out-of-control jumping on us and barking at guests during visits. He had high-anxiety and was (sometimes still is) very stubborn. Todo’s not only trained Elvis to stop pulling on a walk, she trained Elvis to walk next to me on a gentle collar. He now ignores distractions by focusing on me. He doesn’t jump on us and doesn’t bark insanely at visitors. It’s a different dog. Elvis is happier, has less anxiety, and has more control knowing the cues and what action to take. His routine gives him peace. We are no longer frustrated with our loving dog. Our entire house is a better place. Thank you for helping all of us - humans and pups!",
        images: [],
      },
    ],
    soldPuppies: [
      {
        name: "Fozzie",
        when: "Jan 2021",
        breed: "Labradoodle",
        info: "Lives in Fishers IN with one dog and two human siblings.  Comes back home to us when his family goes on vacation.",
      },
      {
        name: "Sullivan",
        when: "Feb 2021",
        breed: "Labradoodle",
        info: "Currently lives in Carmel IN off the Monon with his mom.  Sometimes he gets to tag along to work with her.",
      },
      {
        name: "Luna",
        when: "When sold?",
        breed: "Aussiedoodle",
        info: "lives on a farm in Central IN with her two human siblings.",
      },
      {
        name: "Josie",
        when: "What should these dates be, when they came to justine or when they were sold?",
        breed: "Goldendoodle",
        info: "lives with her dad in Carmel IN.  She's a proper little apartment dog!",
      },
      {
        name: "Grcie, now Pepper",
        when: "What should these dates be, when they came to justine or when they were sold?",
        breed: "Black Lab?",
        info: "Gracie, now Pepper, is currently living in Greenville SC with her mom and lab brother.  She accompanied her mom to the office.",
      },
      {
        name: "Ruckus",
        when: "What should these dates be, when they came to justine or when they were sold?",
        breed: "Ausiedoodle?",
        info: "Gracie, now Pepper, is currently living in Greenville SC with her mom and lab brother.  She accompanied her mom to the office.",
      },
      {
        name: "Rowan",
        when: "What should these dates be, when they came to justine or when they were sold?",
        breed: "Ausiedoodle?",
        info: "Now lives in Milwaukee",
      },
    ],
    puppies: [
      {
        image: "dolly",
        cardHeaderTitle: "Dolly",
        profilePath: "/dolly",
        breed: "Bernedoodle",
        breedLong: "Bernedoodle (25% Bernese mountain dog, 75% poodle)",
        breeder: "",
        projectedSize: "60lbs",
        dob: "12/19/22",
        sex: "Female",
        personality: `Dolly is named for Dolly Parton because she is so stunning and full of life. She is very
        confident and eager to explore new experiences. Dolly has loved meeting new dogs and could
        honestly use a bit more caution. We love how her tail curls up over her back and the white tip becomes
        a blur when she is happy. She is brave as could be but as soon as she is picked up she relaxes into the
        cuddles and nuzzles her head against your neck. Dolly will be a happy adaptable puppy and will do well
        with most any family. She’d love to be with someone who exposes her to things and includes her in
        their fun.`,
        available: true,
        availableDate: "April 2023",
        price: "$8000",
        saleUpdate: ``,
        carousel: () => {
          const path = require.context(
            "../Assets/StockPhotos/Puppies/Dolly",
            false,
            /\.jpeg$/,
          );
          return path.keys().map(path);
        },
      },
      {
        image: "denver",
        cardHeaderTitle: "Denver",
        profilePath: "/denver",
        breed: "Australian Shepherd",
        breeder: `Denver came to us through rescue. I was at lunch with a friend who runs a rescue when she
        received a call about a “breeder” who had to get rid of dogs immediately per city ordinance. We pulled
        22 Australian shepherds from her home that day. Her breeding program and become more of a
        hoarding situation. The dogs were all undercared for and underexposed. The pups were terrified of
        everything. They were one foster short so Denver came to me. All proceeds from Denver’s sale will be
        given to Brown Paws Rescue to compensate for the vet care needed for the older dogs.`,
        projectedSize: "",
        dob: "March 2022",
        sex: "Male",
        personality: `We are all obsessed with Denver. He is the whole package. Denver started of a terrified
        little fluff ball and blossomed into a confident, eager companion. Denny wags his butt so hard that he
        has to walk sideways to accommodate the wiggle. When one of us stands still to long he is immediately
        laying down on our feet. We love using Denver for work (I’m a full time professional dog trainer)
        because he is adaptable, listens well and is unintimidated by naughty dogs. He handles every situation
        we throw at him whether it is just walking loose leash in front of a client’s home, working on greeting
        strange dogs or just teaching appropriate social encounters to other dogs. Denver is so very smart and
        just wants to make the people around him happy. He is the BEST cuddler. We may not want to let him
        go.`,
        available: true,
        availableDate: "August 2022",
        price: "$6000",
        saleUpdate: ``,
        carousel: () => {
          const path = require.context(
            "../Assets/StockPhotos/Puppies/Denver",
            false,
            /\.jpeg$/,
          );
          return path.keys().map(path);
        },
      },
      {
        image: "louise",
        cardHeaderTitle: "Louise",
        profilePath: "/louise",
        breed: "Bernedoodle",
        breedLong: "Bernedoodle (25% Bernese mountain dog, 75% poodle)",
        breeder: "",
        projectedSize: "60lbs",
        dob: "12/19/22",
        sex: "Female",
        personality: `If you’ve watched Bob’s Burgers you’ve seen Louise’s namesake. Just like the character on
        the show Louise is brave, independent and unstoppable. She has enjoyed all of her encounters with
        new things. Pop open an umbrella? Not scary…Lou just runs towards it and drags the umbrella around.
        Louise is very clever and has picked up on all her training very quickly. After getting all her wiggles out
        Louise loves a good snuggle. I expect Louise to be happy in most every home but she will likely enjoy
        being a part of an active family or lifestyle.`,
        available: false,
        availableDate: "April 2023",
        price: "$5500",
        saleUpdate: ``,
        carousel: () => {
          const path = require.context(
            "../Assets/StockPhotos/Puppies/Louise",
            false,
            /\.jpeg$/,
          );
          return path.keys().map(path);
        },
      },
      {
        image: "mango",
        cardHeaderTitle: "Mango",
        profilePath: "/mango",
        breed: "Golden Retriever, AKC",
        breeder: "It’s a Golden Life, OFA cleared parents",
        projectedSize: "",
        dob: "3/9/22",
        sex: "Female",
        personality: `Mango is one of the sweetest souls we have ever trained. We describe her as the perfect
        family dog. She is very sensitive and passive and she brings a calm steady energy. Mango adores all
        kids, they’re the best thing in the world to her. She also looooves to play fetch. If no one throws the ball
        for her she will just bounce it to herself! Mango does well with a routine and when she can be a part of
        everything her family is doing. She also thoroughly enjoys being in her crate when she needs a rest.
        Because Missy Mang is so sensitive she will do best with a gentle family and house full of kids.`,
        available: false,
        availableDate: "August 2022",
        price: "$5000",
        saleUpdate: `Mango now lives in Moorseville, IN with her new family. She is overjoyed to spend her
        days with the family’s three children and tag along when they get dropped off and picked up from
        school. She also gets to go to the office with her new mom! Mango’s mom describes her as her “dream
        dog” and says she can’t be happier. Their only complaint is that she is a bit of a bed hog!`,
        carousel: () => {
          const path = require.context(
            "../Assets/StockPhotos/Puppies/Mango",
            false,
            /\.jpeg$/,
          );
          return path.keys().map(path);
        },
      },
      {
        image: "kiwi",
        cardHeaderTitle: "Kiwi",
        profilePath: "/kiwi",
        breed: "Golden Retriever, AKC",
        breeder: "It’s a Golden Life, OFA cleared parents",
        projectedSize: "",
        dob: "3/9/22",
        sex: "Female",
        personality: `Kiwi is all golden retriever. She is effervescent, eager to please and has never met a dog or
        person who isn’t her friend. Kiwi loves car rides and adventures and is very adaptable to new settings.
        She almost always has a little doggie smile on her face and her happiness is infectious. After a good
        adventure Kiwi loves to cuddle up. She would do well with any person or family who wants to take her
        places and include her in as much as possible.`,
        available: false,
        availableDate: "August 2022",
        price: "$5000",
        saleUpdate: `Kiwi now lives with her family on Indianapolis’ east side and is training to become a
        Service Dog for her parent. Kiwi is soaking up her new skills and building confidence daily. Her parent
        reports that Kiwi is building confidence in her new abilities and has fit right in with her several dog and
        cat siblings.`,
        carousel: () => {
          const path = require.context(
            "../Assets/StockPhotos/Puppies/Kiwi",
            false,
            /\.jpeg$/,
          );
          return path.keys().map(path);
        },
      },
      // {
      //   image: "jolene",
      //   cardHeaderTitle: "Jolene",
      //   profilePath: "/jolene",
      //   breed: "",
      //   breeder: "",
      //   projectedSize: "",
      //   dob: "",
      //   sex: "Female",
      //   personality: "",
      //   available: false,
      //   availableDate: "",
      //   price: "",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Jolene",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      {
        image: "rocky",
        cardHeaderTitle: "Rocky",
        profilePath: "/rocky",
        breed: "Golden Retriever, AKC",
        breeder: "It’s a Golden Life, OFA tested parents",
        projectedSize: "",
        dob: "12/21",
        sex: "Female",
        personality: `Rocky was chosen specifically for his family who lives in Manhattan. The name Rocky is short
        for Rockefeller. Going into it knowing we needed a bomb proof dog who can stroll the streets of New
        York City with no issues as well as live along side two children under the age of two. We struck gold with
        Rocky. Between sound breeding and early socialization and training with his future in mind Rocky
        became an incredibly steady dog. He walks daily through Central Park and loves all the full force
        attention he gets from his toddler sisters.`,
        available: false,
        availableDate: "Went home June 2022",
        price: "unavailable",
        saleUpdate: ``,
        carousel: () => {
          const path = require.context(
            "../Assets/StockPhotos/Puppies/Rocky",
            false,
            /\.jpeg$/,
          );
          return path.keys().map(path);
        },
      },
      {
        image: "tippy",
        cardHeaderTitle: "Tippy",
        profilePath: "/tippy",
        breed: "Cockapoo",
        breedLong: "Cockapoo (cocker spaniel and poodle)",
        breeder: "",
        projectedSize: "",
        dob: "7/21",
        sex: "Male",
        personality: `Tippy is exactly what his family was looking for. They needed a dog that could fit easily into
        their Boston lifestyle and help with transition of their only daughter leaving for college. Tippy helped
        me (as a professional dog trainer) in many lessons with client’s dogs and he was such a sweety pie that
        my clients lovingly called him a ‘marshmallow’. Tippy is a quiet companion and just wants to be close to
        his people. His family reports that he is their perfect little fella and they love including him in everything
        and spoiling him daily.`,
        available: false,
        availableDate: "Went home April 2022",
        price: "unavilable",
        saleUpdate: ``,
        carousel: () => {
          const path = require.context(
            "../Assets/StockPhotos/Puppies/Tippy",
            false,
            /\.jpeg$/,
          );
          return path.keys().map(path);
        },
      },
      // {
      //   image: "rocky", // I have no pictures of this dog
      //   cardHeaderTitle: "Atom",
      //   profilePath: "/atom",
      //   breed: "Golden Retriever, AKC",
      //   breeder: "It’s a Golden Life, OFA tested parents",
      //   projectedSize: "",
      //   dob: "12/21",
      //   sex: "Male",
      //   personality: `Atom was chosen specifically for a couple in Lexington, KY. He is their first dog ever! This
      //   young couple both worked in the chemical science industry, hence the name Atom. They were so
      //   inexperienced with dogs that the wife was initially afraid of Atom. But her fear quickly wore off when
      //   Atom showed her how kind and gentle he was. Atom is full of life and happy to play and be a part of
      //   everything. Since being delivered to his family he has fit right in and become a daily blessing.`,
      //   available: false,
      //   availableDate: "",
      //   price: "unavailable",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Rocky", // I have no pictures of this dog
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      {
        image: "spencer",
        cardHeaderTitle: "Spencer",
        profilePath: "/spencer",
        breed: "Labradoodle",
        breedLong: "Labradoodle (75% poodle, 25% lab)",
        breeder: "Rosie’s Doodles and Poodles",
        projectedSize: "40-50lbs",
        dob: "10/21",
        sex: "Male",
        personality: `Spencer is a happy and fun loving guy. He enjoys a nice long walk and will play fetch as
        long as someone will throw the ball for him. Spence is so clever that he can predict when and where the
        ball will be thrown. It’s so fun to watch him bound like a rabbit after it. Spencer also enjoys a nice car
        ride and cuddles. He is a bit of an over achiever and tries to train even when I’m not training him. Even
        though he is a lively guy Spence also knows when to settle down and is very calm and gentle with
        children and older folks. Spencer would do well with just about any family and just wants to be included!`,
        available: false,
        availableDate: "March 2022",
        price: "unavailable",
        saleUpdate: `Spencer now lives with his retired mom and dad in Carmel IN. His mom tells me regularly
        how blessed she is to have him. Spence is a ray of sunshine in her day and she is dedicated to providing
        him with everything he needs including daily training, playing and walks. Spencer loves helping his mom
        stay active and then comes home and rests his head on dad’s lap afterwards.`,
        carousel: () => {
          const path = require.context(
            "../Assets/StockPhotos/Puppies/Spencer",
            false,
            /\.jpeg$/,
          );
          return path.keys().map(path);
        },
      },
      {
        image: "klaus",
        cardHeaderTitle: "Klaus",
        profilePath: "/klaus",
        breed: "Labradoodle",
        breedLong: "Labradoodle (75% poodle, 25% lab)",
        breeder: "Rosie’s Doodles and Poodles",
        projectedSize: "40-50lbs",
        dob: "10/21",
        sex: "Male",
        personality: `Klaus was very carefully chosen for his family in Fishers, IN. With three school aged children in
        their home and both adults working full time they wanted to be sure that they got a puppy that would
        fit easily into their lives. Klaus was just what they wanted. Klaus loves the busyness of kids in and out of
        the home and is always down for a good cuddle when things settle down. And lucky for us Klaus lives
        close enough to stay with us when his family goes out of town!`,
        available: false,
        availableDate: "March 2022",
        price: "unavailable",
        saleUpdate: ``,
        carousel: () => {
          const path = require.context(
            "../Assets/StockPhotos/Puppies/Klaus",
            false,
            /\.jpeg$/,
          );
          return path.keys().map(path);
        },
      },
      {
        image: "penny",
        cardHeaderTitle: "Penny",
        profilePath: "/penny",
        breed: "Labradoodle",
        breedLong: "Labradoodle (75% poodle, 25% lab)",
        breeder: "Rosie’s Doodles and Poodles",
        projectedSize: "40-50lbs",
        dob: "10/21",
        sex: "Female",
        personality: `Penny is a sensitive quiet gal. She is a people pleaser and loves to be your quiet shadow.
        Penny is a total cuddlebug and wants to be someone’s full focus. She is a delicate spirit and needs
        someone who is gentle and wants to include her in things.`,
        available: false,
        availableDate: "March 2022",
        price: "$4500",
        saleUpdate: `Penny lives with her mom in Indianapolis, IN. She gets to accompany her mom to work at
        an assisted living facility every day and absolutely loves when mom’s grandkids come to visit. Penny
        sleeps in bed every night and wants for nothing.`,
        carousel: () => {
          const path = require.context(
            "../Assets/StockPhotos/Puppies/Penny",
            false,
            /\.jpeg$/,
          );
          return path.keys().map(path);
        },
      },
      // {
      //   image: "rowan",
      //   cardHeaderTitle: "Rowan",
      //   profilePath: "/rowan",
      //   breed: "Goldendoodle",
      //   breeder: "",
      //   projectedSize: "~30lbx",
      //   dob: "8/10/21",
      //   sex: "Female",
      //   personality:
      //     "Rowan is incredibly sweet and calm.  She loves to cuddle and be held.  She is very tolerant with young children and doesn't nip. Rowan has low to medium exercise requirements and will do well with just about any family.  She can't wait to cuddle up with you!",
      //   available: false,
      //   availableDate: "12/23/21",
      //   price: "$4,250",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Rowan",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      // {
      //   image: "kirby",
      //   cardHeaderTitle: "Kirby",
      //   profilePath: "/kirby",
      //   breed: "",
      //   breeder: "",
      //   projectedSize: "",
      //   dob: "",
      //   sex: "Male",
      //   personality: "",
      //   available: false,
      //   availableDate: "",
      //   price: "",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Kirby",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      // {
      //   image: "omega",
      //   cardHeaderTitle: "Omega",
      //   profilePath: "/omega",
      //   breed: " English Cream Golden Retriever, AKC",
      //   breeder: "",
      //   projectedSize: "~70lbs",
      //   dob: "2/10/21",
      //   sex: "Female",
      //   personality:
      //     "Tinker is a very sweet and sensitive gal.  She loves to lay at your feet and get snuggles.  She is fairly calm and attentive.  She can be on the timid side but recovers quickly.  Tinker enjoys being outside and loves playing in the yard, even by herself.  She can be very curious and independent on occasion.  She would fit well in just about any home where she is treated like a valued family member.",
      //   available: false,
      //   availableDate: "June 2021",
      //   price: "$4500",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Omega",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      // {
      //   image: "grace",
      //   cardHeaderTitle: "Grace",
      //   profilePath: "/grace",
      //   breed: "",
      //   breeder: "",
      //   projectedSize: "",
      //   dob: "",
      //   sex: "Female",
      //   personality: "",
      //   available: false,
      //   availableDate: "",
      //   price: "",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Gracie_Pepper",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      // {
      //   image: "ruckus",
      //   cardHeaderTitle: "Ruckus",
      //   profilePath: "/ruckus",
      //   breed: "",
      //   breeder: "",
      //   projectedSize: "",
      //   dob: "",
      //   sex: "Male",
      //   personality: "",
      //   available: false,
      //   availableDate: "",
      //   price: "",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Ruckus",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      // {
      //   image: "josie",
      //   cardHeaderTitle: "Josie",
      //   profilePath: "/josie",
      //   breed: "",
      //   breeder: "",
      //   projectedSize: "",
      //   dob: "",
      //   sex: "Female",
      //   personality: "",
      //   available: false,
      //   availableDate: "",
      //   price: "",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Josie",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      // {
      //   image: "fig",
      //   cardHeaderTitle: "Fig",
      //   profilePath: "/fig",
      //   breed: "",
      //   breeder: "",
      //   projectedSize: "",
      //   dob: "",
      //   sex: "Male",
      //   personality: "",
      //   available: false,
      //   availableDate: "",
      //   price: "",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Fig",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      // {
      //   image: "clover",
      //   cardHeaderTitle: "Clover",
      //   profilePath: "/clover",
      //   breed: "",
      //   breeder: "",
      //   projectedSize: "",
      //   dob: "",
      //   sex: "Female",
      //   personality: "",
      //   available: false,
      //   availableDate: "",
      //   price: "",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Clover",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      // {
      //   image: "captain",
      //   cardHeaderTitle: "Captain",
      //   profilePath: "/captain",
      //   breed: "",
      //   breeder: "",
      //   projectedSize: "",
      //   dob: "",
      //   sex: "Male",
      //   personality: "",
      //   available: false,
      //   availableDate: "",
      //   price: "",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Captain",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      // {
      //   image: "fozzie",
      //   cardHeaderTitle: "Fozzie",
      //   profilePath: "/fozzie",
      //   breed: "Labradoodle",
      //   breeder: "",
      //   projectedSize: "~50lbs",
      //   dob: "11/18/20",
      //   sex: "Male",
      //   personality: "",
      //   available: false,
      //   availableDate: "March 2021",
      //   price: "",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Fozzie",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      // {
      //   image: "sullivan",
      //   cardHeaderTitle: "Sullivan",
      //   profilePath: "/sullivan",
      //   breed: "Labradoodle",
      //   breeder: "",
      //   projectedSize: "~50lbs",
      //   dob: "11/18/20",
      //   sex: "Male",
      //   personality:
      //     "Sweet, quiet and calm.  Playful a few times a day but spends most of his time trying to cuddle.  He loves to lay on your feet or on your lap.  He is very clever and learns quickly.",
      //   available: false,
      //   availableDate: "March 2021",
      //   price: "",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Sullivan",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      // // I don't have pictures of these ones
      // // {
      // //   image: "gnocchi",
      // //   cardHeaderTitle: "Gnocchi",
      // //   profilePath: "/gnocchi",
      // // breed: "",
      // // breeder: "",
      // // projectedSize: "",
      // // dob: "",
      // // sex: "Female",
      // // personality: "",
      // // available: false,
      // // availableDate: "",
      // // price: "",
      // // saleUpdate: ``,
      // // carousel: () => {
      // //   const path = require.context(
      // //     "../Assets/StockPhotos/Puppies/Gnocchi",
      // //     false,
      // //     /\.jpeg$/
      // //   );
      // //   return path.keys().map(path);
      // // },
      // // },
      // // {
      // //   // cherry eye
      // //   image: "nugget",
      // //   cardHeaderTitle: "Nugget",
      // //   profilePath: "/nugget",
      // // breed: "",
      // // breeder: "",
      // // projectedSize: "",
      // // dob: "",
      // // sex: "Female",
      // // personality: "",
      // // available: false,
      // // availableDate: "",
      // // price: "",
      // // saleUpdate: ``,
      // // carousel: () => {
      // //   const path = require.context(
      // //     "../Assets/StockPhotos/Puppies/Nugget",
      // //     false,
      // //     /\.jpeg$/
      // //   );
      // //   return path.keys().map(path);
      // // },
      // // },
      // {
      //   image: "bella",
      //   cardHeaderTitle: "Bella",
      //   profilePath: "/bella",
      //   breed: "",
      //   breeder: "",
      //   projectedSize: "",
      //   dob: "",
      //   sex: "Female",
      //   personality: "",
      //   available: false,
      //   availableDate: "",
      //   price: "",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Bella",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      // {
      //   image: "jasmine", //tan
      //   cardHeaderTitle: "Jasmine",
      //   profilePath: "/jasmine",
      //   breed: "",
      //   breeder: "",
      //   projectedSize: "",
      //   dob: "",
      //   sex: "Female",
      //   personality: "",
      //   available: false,
      //   availableDate: "",
      //   price: "",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Jasmine",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
      // {
      //   image: "opal", //black
      //   cardHeaderTitle: "Opal",
      //   profilePath: "/opal",
      //   breed: "",
      //   breeder: "",
      //   projectedSize: "",
      //   dob: "",
      //   sex: "Female",
      //   personality: "",
      //   available: false,
      //   availableDate: "",
      //   price: "",
      //   saleUpdate: ``,
      //   carousel: () => {
      //     const path = require.context(
      //       "../Assets/StockPhotos/Puppies/Opal",
      //       false,
      //       /\.jpeg$/
      //     );
      //     return path.keys().map(path);
      //   },
      // },
    ],
  })),
);

// const toastFor = (action, successMessage, successCode = 0) => ({
//   message: action.payload?.message || successMessage,
//   statusCode: action.payload?.statusCode || successCode
// });

// Create protected page hook
// export const useProtected = (toastMessage = 'You must be signed in to view this page') => {
//   const { dispatch, user } = useStore();
//   const history = useHistory();

//   useEffect(() => {
//     if (!user.token) {
//       dispatch({ type: actions.TOAST, payload: { message: toastMessage , statusCode: 1 } });
//       history.replace('/login');
//     }
//   }, [user]);
// };

// Custom slow scroll function
export function slowScrollTo(element, duration = 2000) {
  // Get the element's position relative to the viewport
  const elementPosition = element.getBoundingClientRect().top;
  // Get starting position (current scroll position)
  const startPosition = window.pageYOffset;
  // Calculate distance to scroll
  const distance = elementPosition;

  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const scrollY = easeInOutCubic(
      timeElapsed,
      startPosition,
      distance,
      duration,
    );

    window.scrollTo(0, scrollY);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }

  // Easing function for smooth acceleration and deceleration
  function easeInOutCubic(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t * t + b;
    t -= 2;
    return (c / 2) * (t * t * t + 2) + b;
  }

  requestAnimationFrame(animation);
}
